module.exports = __webpack_public_path__ + "img/bottom_icon_shop_t.68a125d2.svg";